<template>
  <div>
    <Header modeType="2" />
    <div class="content-center">
      <div class="banner">
        <div class="content">
          <div class="banner-title">千橙营销</div>
          <div class="line" />
          <div class="desc">
            智能化精准化的会员管理和营销
            <!-- <div class="desc-content">为企业提供业务员外勤管理、销售管理、订单管理、佣金管理、客户管理等销售辅助功能，全面提升销售业绩；基于企业微信，无缝对接企业商城、ERP、WMS、OMS等企业管理系统，构建全链路全闭环的数字化业务体系。</div> -->
          </div>
          <div class="btn-wrap">
            <!-- <div
                class="btn1"
                @click="openModal"
              >免费试用</div> -->
            <div class="btn" @click="openModal">立即咨询</div>
          </div>
        </div>
      </div>
      <div class="improve" style="height:442px;">
          <div class="sk-block-title1">
              <div class="title1">会员营销的七大业务痛点</div>
              <!-- <div class="sub-title1">消费市场的习惯与供需变化，对零售门店的经营增长呈现巨大压力</div> -->
          </div>
          <div class="content1">
  
          </div>
      </div>
      <div class="improve1 " style="height:824px;">
          <div class="sk-block-title1">
              <div class="title1">搭配拉新工具，多渠道引流，解决“获客难”</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content1">
  
          </div>
      </div>
      <div class="improve" style="height:598px;">
          <div class="sk-block-title1">
              <div class="title1">多渠道客户收集与统一管理，解决“管理难”</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content2">
  
          </div>
      </div>
      <div class="improve1 " style="height:668px;">
          <div class="sk-block-title1">
              <div class="title1">完善客户资料，深度客户洞察，解决“识别难”</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content2">
  
          </div>
      </div>
      <div class="improve" style="height:636px;">
          <div class="sk-block-title1">
              <div class="title1">标准化场景及精准化智能化匹配，解决“转化难”问题</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content3">
  
          </div>
      </div>
      <div class="improve1 " style="height:692px;">
          <div class="sk-block-title1">
              <div class="title1">促销与触达形式多样，解决“活跃难”</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content3">
  
          </div>
      </div>
      <div class="improve" style="height:640px;">
          <div class="sk-block-title1">
              <div class="title1">会员忠诚和成长体系打造，解决“留存难”</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content4">
  
          </div>
      </div>
      <div class="improve1 " style="height:668px;">
          <div class="sk-block-title1">
              <div class="title1">效果分析及决策指导，解决“分析难”</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content4">
  
          </div>
      </div>
      <div class="programme">
        <div class="sk-block-title1">
              <div class="title1">多场景多维度营销解决方案</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content">
  
          </div>
      </div>
      
      <Contact :infoSources="'汇通数科官网-千橙营销'" />
      <TryModal
        v-if="visible"
        :visible="visible"
        info-sources="社群分销"
        @cancel="modalClose"
      />
    </div>
    <Footer />
  </div>
  </template>
  
  <script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import metaInfo from "@/common/util/metaInfo";
  import TryModal from "@/components/TryModal";
  import Contact from "@/components/Contact";

  export default {
    metaInfo: metaInfo.QcMarketing,
    components: {
      Header,
      Footer,
      TryModal,
      Contact,
    },
    data() {
      return {
        visible: false,
        toolBg: require("@/assets/images/QcCashier/tool1.png"),
        tooItem: "1",
      };
    },
    mounted() {},
    methods: {
      checkBg(item) {
        this.tooItem = item;
        this.toolBg = "@/assets/images/QcCashier/tool" + item + ".png";
      },
      openModal: function () {
        this.visible = true;
      },
      modalClose: function (data) {
        this.visible = data;
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .programme{
        height:1047px;
        background: #F4F5FB;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content{
          margin-top:49px;
          width: 1200px;
          height:834px;
          background: url("~@/assets/images/QcMarketing/content9.png") no-repeat;
          background-size: 1200px 834px;
      }
  }
  .improve_banner1{
    background-color: #f7f9fb;
        background: url("~@/assets/images/QcMarketing/content_banner1.png") no-repeat center;
        background-size: 1920px 824px;
  }
  .improve_banner2{
        background-color:#f9faff;
        background: url("~@/assets/images/QcMarketing/content_banner2.png") no-repeat center;
        background-size: 1920px 668px;
  }
  .improve_banner3{
    background-color:#f8f9fb;
        background: url("~@/assets/images/QcMarketing/content_banner3.png") no-repeat center;
        background-size: 1920px 692px;
  }
  .improve_banner4{
    background-color:#f8f9fb;
        background: url("~@/assets/images/QcMarketing/content_banner4.png") no-repeat center;
        background-size: 1920px 668px;
  }
  .improve1{
    background-color:#f8f9fb;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content1{
          margin-top:70px;
          width: 1200px;
          height:502px;
          background: url("~@/assets/images/QcMarketing/content2.png") no-repeat;
          background-size: 1200px 502px;
      }
      .content2{
          margin-top:75px;
          width: 1200px;
          height:391px;
          background: url("~@/assets/images/QcMarketing/content4.png") no-repeat;
          background-size: 1200px 391px;
      }
      .content3{
          margin-top:39px;
          width: 1200px;
          height:473px;
          background: url("~@/assets/images/QcMarketing/content6.png") no-repeat;
          background-size: 1200px 473px;
      }
      .content4{
          margin-top:21px;
          width: 1200px;
          height:469px;
          background: url("~@/assets/images/QcMarketing/content8.png") no-repeat;
          background-size: 1200px 469px;
      }
     
  }
  .improve{
      display: flex;
      flex-direction: column;
      // justify-content: center;
    background: #FFFFFF;
      align-items:center;
      .content1{
          margin-top:50px;
          width: 1200px;
          height:248px;
          background: url("~@/assets/images/QcMarketing/content1.png") no-repeat center;
          background-size: 1200px 248px;
      }
      .content2{
          margin-top:41px;
          width: 1200px;
          height:359px;
          background: url("~@/assets/images/QcMarketing/content3.png") no-repeat center;
          background-size: 1200px 359px;
      }
      .content3{
          margin-top:53px;
          width: 1200px;
          height:375px;
          background: url("~@/assets/images/QcMarketing/content5.png") no-repeat center;
          background-size: 1200px 375px;
      }
      .content4{
          margin-top:53px;
          width: 1200px;
          height:404px;
          background: url("~@/assets/images/QcMarketing/content7.png") no-repeat center;
          background-size: 1200px 404px;
      }
  }
  
  /deep/ i.el-icon-arrow-left {
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ i.el-icon-arrow-right{
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  
  .custom{
          height:662px;
          background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
          background-size: 100% 100%;
          display: flex;
          flex-direction: column;
          // justify-content: center;
          align-items:center;
      .content{
          width: 1200px;
          margin: 0 auto;
          padding: 53px 0;
          text-align: left;
          background: rgba(255,255,255,.5);
          // background: #FFFFFF;
          // opacity: 0.55;
          // border-radius: 8px;
          margin-top: 42px;
          height:439px;
          .custom_item{
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              padding:0 150px;
              .cutom_box{
                  width:260px;
                  height:89px;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  margin-top:140px;
                  .box_item{
                      display: flex;
                      flex-direction: column;
                      .box_title{
                          width: 71px;
                          height: 45px;
                          font-size: 32px;
                          font-family: PingFangSC, PingFang SC;
                          font-weight: 600;
                          color: #333333;
                          line-height: 45px;
                      }
                      .box_line{
                          width: 43px;
                          height: 5px;
                          background: #3986FF;
                      }
                      .box_span{
                          width: 96px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #595961;
  line-height: 22px;
                      }
                  }
              }
              .custom_item_text{
                  margin-left: 50px;
                  .title{
                      height: 40px;
                      font-size: 22px;
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 600;
                      color: #333333;
                      line-height: 40px;
                  }
                  .text{
                      height: 20px;
                      font-size: 16px;
                      font-family: PingFangSC, PingFang SC;
                      font-weight: 500;
                      color: #333333;
                      line-height: 20px;
                      margin-top:30px;
                  }
              }
              img{
                  width: 438px;
                  height: 302px;
              }
          }
      }
  }
  .case{
      background: #F8FBFF;
      .content{
          width: 1200px;
          margin: 0 auto;
          padding: 53px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
              width: 1171px;
              height:397px;
          }
      }
  }
  
    .banner {
      background: url("~@/assets/images/QcShopkeeper/QcShopkeeper_banner.png") no-repeat center;
      background-size: 100% 100%;
      min-width: 1200px;
      min-height:420px;
      .content {
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        text-align: left;
        .banner-title {
          font-size: 48px;
          color: #FFFFFF;
          line-height: 55px;
        }
        .line {
          width: 100px;
          height: 6px;
          background: #28DAFB;
          margin: 16px 0 31px;
        }
        .desc {
          width: 600px;
          height: 101px;
          font-size: 20px;
          color: #FFFFFF;
          font-weight: normal;
          line-height: 28px;
          .desc-content{
              width: 600px;
              height: 96px;
              font-size: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 32px;
          }
        }
        .btn-wrap {
          display: flex;
          .btn {
            width: 200px;
            height: 58px;
            line-height: 58px;
            border-radius: 6px;
            border: 1px solid #FFFFFF;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
            // margin-left:20px;
          }
          .btn1 {
            width: 200px;
            height: 58px;
            line-height: 58px;
            background: #3986FF;
            border-radius: 6px;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
          //   margin-left:20px;
          }
        }
      
    }
  
  }
  </style>
  